import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import arrowRight from '../../images/arrow-right.svg';

const StyledBreadcrumbListItem = styled.li`
    display: inline;
    &::before {
        content: '';
        height: 16px;
        width: 16px;
        background: url(${arrowRight}) no-repeat center center;
        padding: 0 1rem;
    }
    & a:visited {
        color: inherit;
    }
`;

const StyledBreadcrumbList = styled.ol`
    font-family: 'Circe Web';
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    list-style-type: none;
    color: #5e5d5c;
    z-index: 10;
    position: relative;

    & li:last-child {
        color: #404040;
    }
    & li:first-child::before {
        content: none;
    }
`;

export const CustomBreadCrumbs = ({ crumbs }) => {
    return (
        <StyledBreadcrumbList
            itemScope
            itemType="https://schema.org/BreadcrumbList"
        >
            {crumbs.map(({ pathname, crumbLabel }, index) => {
                return (
                    <StyledBreadcrumbListItem
                        key={pathname}
                        itemProp="itemListElement"
                        itemScope
                        itemType="https://schema.org/ListItem"
                    >
                        <Link to={pathname} itemProp="item">
                            <span
                                itemProp="name"
                                dangerouslySetInnerHTML={{ __html: crumbLabel }}
                            ></span>
                        </Link>
                        <meta itemProp="position" content={index + 1} />
                    </StyledBreadcrumbListItem>
                );
            })}
        </StyledBreadcrumbList>
    );
};
